export const companyInfo = {
  name: "Eagle Angel Flags",
  phone: "(469) 734-1035",
  phoneRaw: "4697341035",
  location: "Dallas, Texas",
  coverage: "Nationwide Service Available",
  email: "info@eagleangelflags.com"
};

export const services = [
  {
    id: 1,
    title: "Flagpole Repair",
    description: "Expert repair services for damaged or worn flagpoles. We fix mechanical issues, structural damage, and restore your flagpole to perfect condition.",
    icon: "wrench"
  },
  {
    id: 2,
    title: "Flag Replacement",
    description: "Professional flag replacement services. We provide high-quality American flags and ensure proper installation with attention to detail.",
    icon: "flag"
  },
  {
    id: 3,
    title: "Maintenance Services",
    description: "Regular maintenance to keep your flagpole in top condition. Includes cleaning, lubrication, inspection, and preventive care.",
    icon: "settings"
  },
  {
    id: 4,
    title: "Flagpole Installation",
    description: "Complete flagpole installation from foundation to finial. We install residential and commercial flagpoles of all sizes, including large commercial flagpoles over 100 feet tall.",
    icon: "hammer"
  },
  {
    id: 5,
    title: "On-Site Flag Sewing",
    description: "Professional flag sewing services performed on-site. We repair torn flags, reinforce seams, and restore your flags to pristine condition.",
    icon: "scissors"
  }
];

export const installationTypes = [
  {
    id: 1,
    title: "Residential Flagpoles",
    description: "Beautiful flagpoles for your home. Perfect for displaying your patriotism with elegance and pride in your front yard.",
    features: ["15-25 ft poles", "Ground sleeve installation", "Lifetime warranty options", "Professional setup"]
  },
  {
    id: 2,
    title: "Commercial Flagpoles",
    description: "Heavy-duty flagpoles for businesses and organizations. We install commercial flagpoles 100 feet and taller, including 120 ft, 130 ft, and 150 ft large flagpole projects.",
    features: ["25-150+ ft poles", "100+ ft large commercial installations", "Multiple flag configurations", "Wind-resistant design", "Custom lighting systems"]
  },
  {
    id: 3,
    title: "Custom Flagpoles",
    description: "Tailored solutions for unique requirements. We design and install custom flagpoles that meet your specific needs and vision.",
    features: ["Custom heights & finishes", "Special mounting options", "Unique design elements", "Personalized consultation"]
  }
];

export const testimonials = [
  {
    id: 1,
    name: "John Mitchell",
    location: "Dallas, TX",
    rating: 5,
    text: "Eagle Angel Flags installed a beautiful 20-foot flagpole at my home. The team was professional, punctual, and the quality is outstanding. Highly recommend!"
  },
  {
    id: 2,
    name: "Sarah Chen",
    location: "Austin, TX",
    rating: 5,
    text: "We needed repairs on our commercial flagpole and they responded quickly. Fixed everything in one visit and the price was very fair. Excellent service!"
  },
  {
    id: 3,
    name: "Robert Thompson",
    location: "Houston, TX",
    rating: 5,
    text: "From consultation to installation, everything was top-notch. They helped us choose the perfect flagpole for our business and it looks amazing!"
  }
];

export const galleryImages = [
  {
    id: 1,
    title: "Residential Installation",
    description: "Beautiful 20ft flagpole installation in Dallas"
  },
  {
    id: 2,
    title: "Commercial Project",
    description: "50ft commercial flagpole for office complex"
  },
  {
    id: 3,
    title: "Custom Design",
    description: "Custom flagpole with special lighting system"
  },
  {
    id: 4,
    title: "Repair Service",
    description: "Complete flagpole restoration and repair"
  },
  {
    id: 5,
    title: "Memorial Installation",
    description: "Veteran memorial flagpole dedication"
  },
  {
    id: 6,
    title: "Government Building",
    description: "Multiple flagpole installation for municipal building"
  }
];

export const aboutContent = {
  title: "About Eagle Angel Flags",
  description: "Eagle Angel Flags is a premier flagpole installation, repair, and maintenance company based in Dallas, Texas. With years of experience and a commitment to excellence, we also provide expert flag replacement and flag repair services for residential, commercial, and custom clients across the nation.",
  mission: "Our mission is to honor the American flag by providing the highest quality flagpole installations, repairs, and maintenance services. We believe every flag deserves to fly with pride and dignity.",
  values: [
    "Quality craftsmanship in every installation",
    "Respectful handling of the American flag",
    "Prompt and professional service",
    "Customer satisfaction guaranteed"
  ]
};